/**
 * To call: store.dispatch('addExample', '')
 */
const setWorkspaceConnected = ({ commit }, payload) => {
  commit('SET_WORKSPACE_CONNECTED', payload)
}

export { setWorkspaceConnected }
